var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38,
    height: 36.5,
    rx: 4.75,
    fill: "#B6D5B2",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.145 29H6.355C6.12824 29 5.91077 28.921 5.75042 28.7803C5.59008 28.6397 5.5 28.4489 5.5 28.25L5.5 13.685C5.5002 13.4862 5.59041 13.2955 5.7508 13.155L10.2367 9.22C10.3164 9.15004 10.411 9.09458 10.5152 9.05683C10.6194 9.01907 10.731 8.99976 10.8437 9H33.145C33.2573 9 33.3685 9.0194 33.4722 9.05709C33.5759 9.09478 33.6702 9.15002 33.7496 9.21967C33.829 9.28931 33.8919 9.37199 33.9349 9.46299C33.9779 9.55398 34 9.65151 34 9.75V28.25C34 28.3485 33.9779 28.446 33.9349 28.537C33.8919 28.628 33.829 28.7107 33.7496 28.7803C33.6702 28.85 33.5759 28.9052 33.4722 28.9429C33.3685 28.9806 33.2573 29 33.145 29Z",
    stroke: "#24948C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14H10.345C10.5718 14 10.7892 13.921 10.9496 13.7803C11.1099 13.6397 11.2 13.4489 11.2 13.25V9",
    stroke: "#24948C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38,
    height: 36.5,
    rx: 4.75,
    stroke: "#24948C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile2);
export default __webpack_public_path__ + "static/media/file_2.9b457ecf365b04557ba2319b31e37374.svg";
export { ForwardRef as ReactComponent };